import styled from 'styled-components'

export const Wrapper = styled.div`
  > div:first-child {
    width: 50%;
  }
`

export const Title = styled.div`
  margin-top: 20px;
`
